import { render, staticRenderFns } from "./StallholderForm.vue?vue&type=template&id=42a8908e"
import script from "./StallholderForm.vue?vue&type=script&lang=js"
export * from "./StallholderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports